"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowSelectEditor_1 = require("../../../../shared/components/editors/CardRowSelectEditor");
var DlgSelectGameBetLinesDenom = /** @class */ (function (_super) {
    __extends(DlgSelectGameBetLinesDenom, _super);
    function DlgSelectGameBetLinesDenom(props) {
        return _super.call(this, props) || this;
    }
    DlgSelectGameBetLinesDenom.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.dialogTitle,
                line_num: data.lineNum,
                lines_avail: data.linesAvail,
                bet_val: data.betVal,
                bets_avail: data.betsAvail,
                dnm_val: data.dnmVal,
                dnms_avail: data.dnmsAvail
            });
        });
        this.setState({
            visible: false,
            dialogTitle: "",
            line_num: 0,
            lines_avail: [],
            bet_val: 0,
            bets_avail: [],
            dnm_val: 0,
            dnms_avail: []
        });
        this.doReSetRules();
    };
    DlgSelectGameBetLinesDenom.prototype.doReSetRules = function () {
        this.setState({
            line_num_rules: { isError: false },
            bet_val_rules: { isError: false },
            dnm_val_rules: { isError: false }
        });
    };
    DlgSelectGameBetLinesDenom.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgSelectGameBetLinesDenom.prototype.isDataValid = function () {
        this.doReSetRules();
        var is_data_valid = true;
        if (this.state.bet_val <= 0) {
            this.setState({
                bet_val_rules: {
                    isError: true,
                    errorMessage: "Поле [Размер ставки] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        if (this.state.line_num <= 0) {
            this.setState({
                line_num_rules: {
                    isError: true,
                    errorMessage: "Поле [Кол-во линий] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        if (this.state.dnm_val <= 0) {
            this.setState({
                dnm_val_rules: {
                    isError: true,
                    errorMessage: "Поле [Деноминация] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        return is_data_valid;
    };
    DlgSelectGameBetLinesDenom.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.line_num, this.state.bet_val, this.state.dnm_val);
            }
        }
    };
    DlgSelectGameBetLinesDenom.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgSelectGameBetLinesDenom.prototype.render = function () {
        var _this = this;
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: true, maskClosable: false, okType: "primary", style: { minWidth: 600 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Кол-во линий:", placeholder: "Выберите количество линий" }, value: { key: this.state.line_num, value: this.state.line_num.toString() }, onValueChanged: function (newVal) {
                        _this.setState({
                            line_num: newVal.key,
                            line_num_rules: { isError: false }
                        }, function () {
                            _this.props.controller.SetLineNum(_this.state.line_num);
                        });
                    }, items: this.state.lines_avail, required: true, rules: this.state.line_num_rules }),
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Размер ставки:", placeholder: "Выберите размер ставки" }, value: { key: this.state.bet_val, value: this.state.bet_val.toString() }, onValueChanged: function (newVal) {
                        _this.setState({
                            bet_val: newVal.key,
                            bet_val_rules: { isError: false }
                        }, function () {
                            _this.props.controller.SetBetVal(_this.state.bet_val);
                        });
                    }, items: this.state.bets_avail, required: true, rules: this.state.bet_val_rules }),
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Деноминация:", placeholder: "Выберите значение деноминации" }, value: { key: this.state.dnm_val, value: this.state.dnm_val.toFixed(2) }, onValueChanged: function (newVal) {
                        _this.setState({
                            dnm_val: newVal.key,
                            dnm_val_rules: { isError: false }
                        }, function () {
                            _this.props.controller.SetDnmVal(_this.state.dnm_val);
                        });
                    }, items: this.state.dnms_avail, required: true, rules: this.state.dnm_val_rules, floatKey: true })));
    };
    return DlgSelectGameBetLinesDenom;
}(React.Component));
exports.default = DlgSelectGameBetLinesDenom;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgSelectGameBetLinesDenom.tsx
// module id = 2489
// module chunks = 0